import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Router } from '@angular/router'
import { CmsParagraphComponent } from '@spartacus/core'
import { CmsComponentData, ParagraphComponent } from '@spartacus/storefront'

@Component({
  selector: 'app-custom-paragraph',
  templateUrl: './custom-paragraph.component.html',
  styleUrls: ['./custom-paragraph.component.scss'],
  standalone: false
})
export class CustomParagraphComponent extends ParagraphComponent implements OnInit {
  constructor(
    component: CmsComponentData<CmsParagraphComponent>,
    private domSanitizer: DomSanitizer,
    router: Router
  ) {
    super(component, router)
  }
  public paragraphData: SafeHtml
  public styleClasses: string | undefined

  ngOnInit() {
    this.component.data$.subscribe((data) => {
      if (data.content) {
        this.paragraphData = this.domSanitizer.bypassSecurityTrustHtml(this.convertLocalLinks(data.content))
        this.styleClasses = data.styleClasses
      }
    })
  }

  public convertLocalLinks(htmlStringData: string): string {
    const htmlData = new DOMParser().parseFromString(htmlStringData, 'text/html')
    const anchoreTags = htmlData.getElementsByTagName('a')
    for (let i = 0; i < anchoreTags.length; i++) {
      const anchoreTag = anchoreTags[i]
      const hrefProperty = anchoreTag.getAttribute('href')
      if (hrefProperty) {
        if (hrefProperty.startsWith('#')) {
          const currentUrl = window.location.origin + window.location.pathname
          anchoreTag.setAttribute('href', currentUrl + hrefProperty)
        }
      }
    }
    return htmlData.body.innerHTML
  }
}
